import {
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  LinearProgress,
  SelectChangeEvent,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import GenericTable from "../HealthCareReview/GenericTable";
import ViewResidentPersonalInfo from "./ResidentsView/PersonalInfoView";
import ResidentCommunityInfo from "./ResidentsView/CommunityDetailsView";
import { ReactNode, Component, ChangeEvent } from "react";
import { ListResidentsQuery, ListResidentsQueryVariables } from "../../API";
import * as queries from "../../graphql/queries";
import { generateClient } from "aws-amplify/api";
import { GraphQLResult, GraphQLOptionsV6 } from "@aws-amplify/api-graphql";
import { ExportCsv } from "@material-table/exporters";
const client = generateClient();
interface Resident {
  phone: string;
  email: string;
  activationStatus: string;
  birthDate: string;
  firstName: string;
  lastName: string;
  community: string;
  salesforceID: string;
}
const getResidentsQuery = `
query {
listResidents<<filter>> {
  items {
      id
      touchtownUpdateStatus
      firstName
      lastName
      activationStatus
      birthDate
      community
      phone
      email
      salesforceID
    }
    nextToken
}
}
`;
const views = ["communityDetailsView", "personalInfoView"].map((c: string) => (
  <MenuItem value={c} key={c}>
    {c}
  </MenuItem>
));
const communityItems = [
  "All",
  "ACH",
  "APL",
  "APR",
  "BBV",
  "CCI",
  "CCV",
  "DVF",
  "ELM",
  "ETH",
  "FRV",
  "GSV",
  "HSD",
  "LHN",
  "LPH",
  "MGC",
  "OCV",
  "RWV",
  "SBV",
  "SLN",
  "TCK",
  "TGB",
  "WCD",
  "WRC",
].map((c: string) => (
  <MenuItem value={c} key={c}>
    {c}
  </MenuItem>
));

async function gql<T extends object>(
  options: GraphQLOptionsV6<any, any>,
  additionalHeaders?: Record<string, string>
): Promise<GraphQLResult<T>> {
  const query = await client.graphql(options, additionalHeaders);

  return query as GraphQLResult<T>;
}
export default function ResidentsFunctional() {
  const [residents, setResidents] = useState<any>([]);
  const [selectedCommunity, setSelectedCommunity] = useState("All");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    loadResidentsList(selectedCommunity);
  }, []);
  const onCommunityChange = async (
    event: SelectChangeEvent<string>,
    child: ReactNode
  ) => {
    //syncTT(residents[0].id)
    const community: string = event.target.value || "All";
    setSelectedCommunity(community);
    loadResidentsList(community);
    setIsLoading(false);
  };
  const onViewChange = async (
    event: SelectChangeEvent<string>,
    child: ReactNode
  ) => {
    //event.preventDefault();
    const view: string = event.target.value || "All";
    setSelectedCommunity(view);
    loadResidentsList(view);
    setIsLoading(false);
  };
  const handleTouchTownStatusUpdate = (index: number) => {
    console.log(index);
    return index % 2 ? "#DDD" : "#EEE";
    // if(residents[index].activationStatus !== null){
    //    if(residents[index].activationStatus == false){
    //     return "#FF0000"
    //  }
    //    else{
    //
    //   }
    // }else{
    //   return "#FFFF00"
    // }
  };
  const loadResidentsAPI = async (
    token: String | undefined,
    filterParsed?: any,
    pageSize?: number
  ) => {
    const listResidents = /* GraphQL */ `
      query ListResidents(
        $filter: ModelResidentFilterInput
        $limit: Int
        $nextToken: String
      ) {
        listResidents(filter: $filter, limit: $limit, nextToken: $nextToken) {
          items {
            id
            firstName
            lastName
            activationStatus
            active
            birthDate
            community
            phone
            salesforceID
            email
          }
          nextToken
        }
      }
    `;
    //console.log("in load residents" + token);

    if (filterParsed == "All") {
      const query = gql<ListResidentsQuery[]>({
        query: listResidents,
        variables: { limit: pageSize, nextToken: token },
      });
      return query;
    } else {
      let filters = {
        community: {
          eq: filterParsed,
        },
      };
      const query = gql<ListResidentsQuery[]>({
        query: listResidents,
        variables: { limit: pageSize, filter: filters, nextToken: token },
      });
      return query;
    }
  };
  const syncTT = async (id: string | undefined) => {
    console.log(id);
    // await API.graphql(graphqlOperation(queries.gqlSyncTouchtown,
    //   { id })) as GraphQLResult<GqlSyncTouchtownQuery>;
  };
  const syncPing = async (id: string | undefined) => {
    // await API.graphql(graphqlOperation(queries.gqlSyncPing,
    //   { id })) as GraphQLResult<GqlSyncPingQuery>;
  };
  const loadResidentsList = async (community: string | undefined) => {
    setIsLoading(true);
    setResidents([]);
    const residentsList = Array();
    try {
      let nextToken = undefined;

      do {
        //The performance significantly decreases as the difference between the page size and the amount of records increases
        const prom = loadResidentsAPI(nextToken, community, 1000) as Promise<
          GraphQLResult<ListResidentsQuery[]>
        >;

        //@ts-ignore
        nextToken = prom.data?.listResidents.nextToken;
        //@ts-ignore
        const itemsList = prom.data?.listResidents.items;
        //for (let i = 0; i < itemsList.length; i++) {
        residentsList.push(...itemsList);
        //}
        // for (let i = 0; i < itemsList.length; i++) {
        //   residentsList.push(itemsList[i]);
        // }
      } while (nextToken);
      setResidents(residentsList);
      setIsLoading(false);
    } catch (error) {
      //console.log(error)

      setIsLoading(false);
      setResidents([]);
    }
  };

  return (
    <React.Fragment>
      <div className="full-table">
        <div className="main-search-wrapper">
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={3}
          >
            <Grid item xs={12} sm={6} md={3} sx={{ ml: 2 }}>
              <InputLabel id="community">Community</InputLabel>
              <Select
                fullWidth
                labelId="community"
                value={selectedCommunity}
                onChange={onCommunityChange}
              >
                {communityItems}
              </Select>
            </Grid>
            {/* <Grid item xs={12} sm={6} md={5}sx={{mr:2}}>
               <InputLabel id="search">Search</InputLabel>
              <TextField  label="searchBox" fullWidth onChange={onSearchKeyChanged} />
            </Grid> */}
          </Grid>
        </div>

        <div style={{ minHeight: 5, width: "100%" }}>
          {isLoading && <LinearProgress />}
        </div>

        <GenericTable
          title="Resident Records"
          columns={[
            {
              title: "ID",
              field: "id",
              width: 100,
            },
            {
              title: "Salesforce ID",
              field: "salesforceID",
              width: 100,
            },
            {
              title: "TT",
              field: "touchtownUpdateStatus",
              width: 100,
            },
            {
              title: "Activation Status",
              field: "activationStatus",
              width: 100,
            },
            {
              title: "First Name",
              field: "firstName",
              //defaultSort: "asc",
              width: 100,
            },
            {
              title: "Last Name",
              field: "lastName",
              width: 100,
            },
            {
              title: "Dob",
              field: "birthDate",
              width: 100,
            },
            {
              title: "Email",
              field: "email",
              width: 100,
            },
            {
              title: "Community",
              field: "community",
              width: 100,
            },
            {
              title: "Phone",
              field: "phone",
              width: 100,
            },
          ]}
          data={residents}
          //onFilter={onSearchKeyChanged}
          isLoading={isLoading}
          grouping={true}
          optionOverrides={{
            exportAllData: true,
            rowStyle: (_, index) => ({
              backgroundColor: handleTouchTownStatusUpdate(index),
            }),
            exportMenu: [
              {
                label: "Export CSV",
                exportFunc: (cols, datas) => ExportCsv(cols, datas, "Resident"),
              },
            ],
            search: true,
          }}
        />

        {residents.length === 0 && (
          <div>No employee file found with that filter</div>
        )}
      </div>
    </React.Fragment>
  );
}
